import React, { useState } from 'react';
import axios from 'axios';

function AddNewClassified() {
    const [formData, setFormData] = useState({
        classified: '',
        isActive: false
    });

    const [errors, setErrors] = useState({});
    const [successMessage, setSuccessMessage] = useState('');
    const [submitError, setSubmitError] = useState('');

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData({
            ...formData,
            [name]: type === 'checkbox' ? checked : value
        });
    };

    const validate = () => {
        let tempErrors = {};
        let isValid = true;

        if (!formData.classified.trim()) {
            tempErrors.classified = 'Please enter a classified name.';
            isValid = false;
        }

        setErrors(tempErrors);
        return isValid;
    };

    const handleSubmit = async (e) => {
    e.preventDefault();

    if (validate()) {
        try {
            const response = await axios.post('https://backend-zkgn.onrender.com/api/classified', {
                classified_name: formData.classified,
                isActive: formData.isActive ? 1 : 0
            });

            if (response.status === 201 || response.status === 200) {
                setSuccessMessage('Classified added successfully!');
                setSubmitError('');
                setFormData({
                    classified: '',
                    isActive: false
                });

                setTimeout(() => setSuccessMessage(''), 3000);
            } else {
                setSubmitError('Failed to add classified. Try again.');
            }
        } catch (error) {
            console.error('Error submitting classified:', error);
            setSubmitError('Error connecting to the server.');
        }
    }
};

    return (
        <div className="container my-5">
            {successMessage && (
                <div className="alert alert-success text-center">{successMessage}</div>
            )}
            {submitError && (
                <div className="alert alert-danger text-center">{submitError}</div>
            )}

            <form onSubmit={handleSubmit} className="shadow p-4 rounded bg-light">
                <div className="mb-3">
                    <label className="form-label">Classified Name</label>
                    <input
                        type="text"
                        className="form-control"
                        name="classified"
                        value={formData.classified}
                        onChange={handleChange}
                    />
                    {errors.classified && <small className="text-danger">{errors.classified}</small>}
                </div>

                <div className="form-check mb-3">
                    <input
                        className="form-check-input"
                        type="checkbox"
                        name="isActive"
                        checked={formData.isActive}
                        onChange={handleChange}
                        id="isActiveCheck"
                    />
                    <label className="form-check-label" htmlFor="isActiveCheck">
                        Active
                    </label>
                </div>

                <div className="text-center">
                    <button type="submit" className="btn btn-primary px-4">Add Classified</button>
                </div>
            </form>
        </div>
    );
}

export default AddNewClassified;
